// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para el modal de cambio de residencia */

.residence-change-modal {
  position: relative;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.btn-close-external {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 1.1rem;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-close-external:hover {
  color: #dc3545;
  background: rgba(255, 255, 255, 1);
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.modal-header {
  background-color: transparent;
  border-bottom: none;
  padding: 1rem;
}

.modal-title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  margin-top: 2rem;
  justify-content: center;
  padding: 1rem 1rem 0 1rem;
  width: 100%;
}

.modal-icon {
  font-size: 2rem;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6b35;
}

.modal-icon-img {
  width: 5rem;
  height: 5rem;
  object-fit: contain;
}

.modal-title {
  color: #2c3e50;
  font-weight: 400;
  font-size: 0.7rem;
  margin: 0;
  text-align: center;
  line-height: 1.2;
  letter-spacing: 0.1px;
  white-space: nowrap;
  width: 100%;
  margin-top: 1.2rem;
}

.modal-body {
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  /* Scrollbar visible para personas mayores */
  scrollbar-width: auto; /* Firefox */
  scrollbar-color: #cbd5e0 #f7fafc; /* Firefox */
}

/* Scrollbar visible para Webkit (Chrome, Safari, Edge) */
.modal-body::-webkit-scrollbar {
  width: 12px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f7fafc;
  border-radius: 6px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 6px;
  border: 2px solid #f7fafc;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.form-group {
  margin-bottom: 1rem;
}

.form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* Estilos para el select de países con banderas usando ng-select */
.country-select-ng {
  width: 100% !important;
  display: block;
}

.country-select-ng ::ng-deep .ng-select {
  width: 100% !important;
}

.country-select-ng ::ng-deep .ng-select-container {
  min-height: 38px;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  width: 100% !important;
}

.country-select-ng ::ng-deep .ng-select-container:hover {
  border-color: #86b7fe;
}

.country-select-ng ::ng-deep .ng-select.ng-select-focused .ng-select-container {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.country-select-ng ::ng-deep .ng-value-container {
  padding-left: 0.5rem;
}

/* Asegurar que el contenedor del form-group ocupe todo el ancho */
.form-group {
  width: 100%;
}

.country-select-ng ::ng-deep .ng-placeholder {
  color: #6c757d;
}

/* Estilos para las opciones con banderas */
.country-option {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.country-option .flag-icon {
  flex-shrink: 0;
  object-fit: contain;
  vertical-align: middle;
}

.country-select-ng ::ng-deep .ng-option {
  padding: 0.5rem 0.75rem;
}

.country-select-ng ::ng-deep .ng-option.ng-option-marked {
  background-color: #f8f9fa;
}

.country-select-ng ::ng-deep .ng-option.ng-option-selected {
  background-color: #e7f3ff;
  color: #004085;
}

.form-control:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.address-input-wrapper {
  position: relative;
}

.address-input {
  width: 100%;
}

/* Estilos para PlaceAutocompleteElement */
gmp-place-autocomplete {
  width: 100%;
  display: block;
  color-scheme: light !important;
  --color-scheme: light !important;
}

/* Forzar tema claro en todo el web component */
gmp-place-autocomplete,
gmp-place-autocomplete *,
gmp-place-autocomplete::part(input),
gmp-place-autocomplete::part(input) * {
  color-scheme: light !important;
  --color-scheme: light !important;
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
}

gmp-place-autocomplete::part(input) {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  font-size: 1rem;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
}

gmp-place-autocomplete::part(input):focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  outline: 0;
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
}

gmp-place-autocomplete::part(input):hover {
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
}

gmp-place-autocomplete::part(input)::placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #6c757d !important;
}

gmp-place-autocomplete::part(input)::-webkit-input-placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #6c757d !important;
}

gmp-place-autocomplete::part(input)::-moz-placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
}

gmp-place-autocomplete::part(input)::-ms-input-placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
}

gmp-place-autocomplete::part(suggestions) {
  background: white;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

gmp-place-autocomplete::part(suggestion) {
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f8f9fa;
}

gmp-place-autocomplete::part(suggestion):hover {
  background-color: #f8f9fa;
}

gmp-place-autocomplete::part(suggestion):last-child {
  border-bottom: none;
}

/* Estilos profesionales para SweetAlert */
.swal2-popup-professional {
  border-radius: 16px !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
  border: 1px solid rgba(255, 107, 53, 0.1) !important;
}

.swal2-title-professional {
  color: #2c3e50 !important;
  font-weight: 600 !important;
  font-size: 1.3rem !important;
  margin-bottom: 1.5rem !important;
}

.swal2-confirm-professional {
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 0.75rem 2rem !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3) !important;
  transition: all 0.2s ease !important;
}

.swal2-confirm-professional:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(255, 107, 53, 0.4) !important;
}

.swal2-cancel-professional {
  background: #6c757d !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 0.75rem 2rem !important;
  font-weight: 600 !important;
  font-size: 0.95rem !important;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3) !important;
  transition: all 0.2s ease !important;
}

.swal2-cancel-professional:hover {
  background: #5a6268 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4) !important;
}

/* Estilos para inputs del popup */
.swal2-input:focus {
  border-color: #ff6b35 !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 107, 53, 0.25) !important;
  outline: none !important;
}

.swal2-input {
  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;
}

.manual-link {
  margin-top: 0.5rem;
}

.manual-link a {
  color: #0d6efd;
  text-decoration: none;
  font-size: 0.875rem;
}

.manual-link a:hover {
  text-decoration: underline;
}

.upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out;
}

.upload-area:hover {
  border-color: #0d6efd;
}

.upload-area.dragover {
  border-color: #0d6efd;
  background-color: rgba(13, 110, 253, 0.05);
}

.upload-icon {
  font-size: 2rem;
  color: #6c757d;
  margin-bottom: 0.5rem;
}

.upload-text {
  color: #6c757d;
  margin-bottom: 0.25rem;
}

.upload-hint {
  font-size: 0.875rem;
  color: #adb5bd;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  text-align: right;
  flex-shrink: 0;
  background-color: #fff;
}

.btn {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.btn-primary {
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
}

.btn-primary:hover {
  color: #fff;
  background-color: #0b5ed7;
  border-color: #0a58ca;
}

.btn-warning {
  color: #fff;
  background-color: #fd7e14;
  border-color: #fd7e14;
}

.btn-warning:hover {
  color: #fff;
  background-color: #e8690b;
  border-color: #e8690b;
}

.btn-warning:disabled {
  opacity: 0.65;
  pointer-events: none;
  background-color: #fd7e14;
  border-color: #fd7e14;
}

.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #5c636a;
  border-color: #565e64;
}

.btn:disabled {
  opacity: 0.65;
  pointer-events: none;
}

/* Estilos para campos manuales */
.manual-fields {
  margin-top: 1rem;
}

.manual-fields .form-group {
  margin-bottom: 0.75rem;
}

/* Estilos para validación */
.form-control.is-invalid {
  border-color: #dc3545;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='m5.8 4.6 2.4 2.4m0-2.4L5.8 7'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

/* Estilos para el estado de carga */
.loading {
  opacity: 0.6;
  pointer-events: none;
}

.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  vertical-align: text-bottom;
  border: 0.125em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

/* Estilos para la nueva funcionalidad de autosuggest */

.country-support-info {
  margin-bottom: 0.75rem;
  padding: 0.5rem;
  border-radius: 0.375rem;
  background-color: #f8f9fa;
  border-left: 3px solid #17a2b8;
}

.country-support-info .text-warning {
  background-color: #fff3cd;
  border-left-color: #ffc107;
  padding: 0.5rem;
  border-radius: 0.375rem;
}

.manual-link {
  margin-top: 0.5rem;
}

.manual-link a {
  color: #007bff;
  text-decoration: none;
  font-size: 0.875rem;
  display: inline-flex;
  align-items: center;
  transition: color 0.2s ease;
}

.manual-link a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.address-input-wrapper {
  position: relative;
}

.address-input {
  padding-right: 2.5rem;
}

.manual-address-fields {
  border: 1px solid #e9ecef;
  border-radius: 0.375rem;
  padding: 1rem;
  background-color: #f8f9fa;
}

/* Mejoras visuales para el autocompletado de Google Maps */
.pac-container {
  border-radius: 0.375rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border: 1px solid #dee2e6;
  margin-top: 0.25rem;
}

.pac-item {
  padding: 0.75rem;
  border-bottom: 1px solid #f1f3f4;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.pac-item:hover {
  background-color: #f8f9fa;
}

.pac-item-selected {
  background-color: #e3f2fd;
}

.pac-matched {
  font-weight: 600;
  color: #1976d2;
}

/* Estilos para la dirección seleccionada */
.selected-address-display {
  margin-top: 1rem;
}

.selected-address-display .alert {
  border-radius: 0.5rem;
  border: 1px solid #b3d7ff;
  background-color: #e7f3ff;
  color: #004085;
  padding: 0.75rem 1rem;
}

.selected-address-display .alert strong {
  color: #002752;
}

/* Estilos globales para forzar tema claro en Google Maps */
:root {
  color-scheme: light !important;
}

/* Forzar estilos en el web component de Google Maps */
gmp-place-autocomplete {
  color-scheme: light !important;
  --color-scheme: light !important;
  --gm-input-color: #495057 !important;
  --gm-input-background: #ffffff !important;
  --gm-input-border: #ced4da !important;
  --gm-input-placeholder-color: #6c757d !important;
}

/* Estilos ultra específicos para el input */
gmp-place-autocomplete::part(input) {
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
  color-scheme: light !important;
  --color-scheme: light !important;
}

/* Forzar estilos en todos los estados del input */
gmp-place-autocomplete::part(input):focus,
gmp-place-autocomplete::part(input):hover,
gmp-place-autocomplete::part(input):active,
gmp-place-autocomplete::part(input):visited {
  color: #495057 !important;
  background-color: #ffffff !important;
  -webkit-text-fill-color: #495057 !important;
}

/* Estilos para el placeholder en todos los navegadores */
gmp-place-autocomplete::part(input)::placeholder,
gmp-place-autocomplete::part(input)::-webkit-input-placeholder,
gmp-place-autocomplete::part(input)::-moz-placeholder,
gmp-place-autocomplete::part(input)::-ms-input-placeholder,
gmp-place-autocomplete::part(input)::-ms-placeholder {
  color: #6c757d !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #6c757d !important;
}

/* Estilos para scroll suave */
.modal-body::-webkit-scrollbar {
  width: 6px;
}

.modal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.modal-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Estilos para el header fijo */
.modal-header {
  flex-shrink: 0;
  background-color: #fff;
  z-index: 10;
}

/* Responsive para la nueva funcionalidad */
@media (max-width: 768px) {
  .residence-change-modal {
    max-height: 85vh;
  }
  
  .modal-body {
    padding: 1rem;
  }
  
  .manual-address-fields {
    padding: 0.75rem;
  }
  
  .country-support-info {
    font-size: 0.8rem;
  }
  
  .manual-link a {
    font-size: 0.8rem;
  }
  
  .selected-address-display .alert {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
}

/* Para pantallas muy pequeñas */
@media (max-width: 480px) {
  .residence-change-modal {
    max-height: 90vh;
  }
  
  .modal-body {
    padding: 0.75rem;
  }
  
  .modal-footer {
    padding: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/my-profile/residence-change-modal/residence-change-modal.component.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,qBAAqB,EAAE,YAAY;EACnC,gCAAgC,EAAE,YAAY;AAChD;;AAEA,yDAAyD;AACzD;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,wEAAwE;AAC1E;;AAEA,mEAAmE;AACnE;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;;;;EAIE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,wEAAwE;EACxE,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,UAAU;EACV,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,wEAAwE;EACxE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;EAC7B,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,6BAA6B;EAC7B,0DAA0D;EAC1D,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0DAA0D;AAC5D;;AAEA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,4DAA4D;EAC5D,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;EAC7B,qIAAqI;AACvI;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,oCAAoC;EACpC,mRAAmR;EACnR,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kCAAkC;EAClC,+BAA+B;EAC/B,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uDAAuD;;AAEvD;EACE,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;EACpC,yCAAyC;EACzC,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA,4CAA4C;AAC5C;EACE,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;EAC3C,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;;;;EAIE,yBAAyB;EACzB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA,yDAAyD;AACzD;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,sBAAsB;EACtB,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Estilos para el modal de cambio de residencia */\n\n.residence-change-modal {\n  position: relative;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.btn-close-external {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.9);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 1.1rem;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.btn-close-external:hover {\n  color: #dc3545;\n  background: rgba(255, 255, 255, 1);\n  transform: scale(1.05);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  background-color: transparent;\n  border-bottom: none;\n  padding: 1rem;\n}\n\n.modal-title-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.2rem;\n  margin-top: 2rem;\n  justify-content: center;\n  padding: 1rem 1rem 0 1rem;\n  width: 100%;\n}\n\n.modal-icon {\n  font-size: 2rem;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ff6b35;\n}\n\n.modal-icon-img {\n  width: 5rem;\n  height: 5rem;\n  object-fit: contain;\n}\n\n.modal-title {\n  color: #2c3e50;\n  font-weight: 400;\n  font-size: 0.7rem;\n  margin: 0;\n  text-align: center;\n  line-height: 1.2;\n  letter-spacing: 0.1px;\n  white-space: nowrap;\n  width: 100%;\n  margin-top: 1.2rem;\n}\n\n.modal-body {\n  padding: 1.5rem;\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  /* Scrollbar visible para personas mayores */\n  scrollbar-width: auto; /* Firefox */\n  scrollbar-color: #cbd5e0 #f7fafc; /* Firefox */\n}\n\n/* Scrollbar visible para Webkit (Chrome, Safari, Edge) */\n.modal-body::-webkit-scrollbar {\n  width: 12px;\n}\n\n.modal-body::-webkit-scrollbar-track {\n  background: #f7fafc;\n  border-radius: 6px;\n}\n\n.modal-body::-webkit-scrollbar-thumb {\n  background: #cbd5e0;\n  border-radius: 6px;\n  border: 2px solid #f7fafc;\n}\n\n.modal-body::-webkit-scrollbar-thumb:hover {\n  background: #a0aec0;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-label {\n  font-weight: 500;\n  color: #495057;\n  margin-bottom: 0.5rem;\n}\n\n.form-control {\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  padding: 0.5rem 0.75rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n/* Estilos para el select de países con banderas usando ng-select */\n.country-select-ng {\n  width: 100% !important;\n  display: block;\n}\n\n.country-select-ng ::ng-deep .ng-select {\n  width: 100% !important;\n}\n\n.country-select-ng ::ng-deep .ng-select-container {\n  min-height: 38px;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  width: 100% !important;\n}\n\n.country-select-ng ::ng-deep .ng-select-container:hover {\n  border-color: #86b7fe;\n}\n\n.country-select-ng ::ng-deep .ng-select.ng-select-focused .ng-select-container {\n  border-color: #86b7fe;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.country-select-ng ::ng-deep .ng-value-container {\n  padding-left: 0.5rem;\n}\n\n/* Asegurar que el contenedor del form-group ocupe todo el ancho */\n.form-group {\n  width: 100%;\n}\n\n.country-select-ng ::ng-deep .ng-placeholder {\n  color: #6c757d;\n}\n\n/* Estilos para las opciones con banderas */\n.country-option {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.country-option .flag-icon {\n  flex-shrink: 0;\n  object-fit: contain;\n  vertical-align: middle;\n}\n\n.country-select-ng ::ng-deep .ng-option {\n  padding: 0.5rem 0.75rem;\n}\n\n.country-select-ng ::ng-deep .ng-option.ng-option-marked {\n  background-color: #f8f9fa;\n}\n\n.country-select-ng ::ng-deep .ng-option.ng-option-selected {\n  background-color: #e7f3ff;\n  color: #004085;\n}\n\n.form-control:focus {\n  border-color: #86b7fe;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.address-input-wrapper {\n  position: relative;\n}\n\n.address-input {\n  width: 100%;\n}\n\n/* Estilos para PlaceAutocompleteElement */\ngmp-place-autocomplete {\n  width: 100%;\n  display: block;\n  color-scheme: light !important;\n  --color-scheme: light !important;\n}\n\n/* Forzar tema claro en todo el web component */\ngmp-place-autocomplete,\ngmp-place-autocomplete *,\ngmp-place-autocomplete::part(input),\ngmp-place-autocomplete::part(input) * {\n  color-scheme: light !important;\n  --color-scheme: light !important;\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\ngmp-place-autocomplete::part(input) {\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\ngmp-place-autocomplete::part(input):focus {\n  border-color: #86b7fe;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n  outline: 0;\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\ngmp-place-autocomplete::part(input):hover {\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\ngmp-place-autocomplete::part(input)::placeholder {\n  color: #6c757d !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #6c757d !important;\n}\n\ngmp-place-autocomplete::part(input)::-webkit-input-placeholder {\n  color: #6c757d !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #6c757d !important;\n}\n\ngmp-place-autocomplete::part(input)::-moz-placeholder {\n  color: #6c757d !important;\n  opacity: 1 !important;\n}\n\ngmp-place-autocomplete::part(input)::-ms-input-placeholder {\n  color: #6c757d !important;\n  opacity: 1 !important;\n}\n\ngmp-place-autocomplete::part(suggestions) {\n  background: white;\n  border: 1px solid #ced4da;\n  border-radius: 0.375rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\ngmp-place-autocomplete::part(suggestion) {\n  padding: 0.5rem 0.75rem;\n  cursor: pointer;\n  border-bottom: 1px solid #f8f9fa;\n}\n\ngmp-place-autocomplete::part(suggestion):hover {\n  background-color: #f8f9fa;\n}\n\ngmp-place-autocomplete::part(suggestion):last-child {\n  border-bottom: none;\n}\n\n/* Estilos profesionales para SweetAlert */\n.swal2-popup-professional {\n  border-radius: 16px !important;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;\n  border: 1px solid rgba(255, 107, 53, 0.1) !important;\n}\n\n.swal2-title-professional {\n  color: #2c3e50 !important;\n  font-weight: 600 !important;\n  font-size: 1.3rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.swal2-confirm-professional {\n  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%) !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 0.75rem 2rem !important;\n  font-weight: 600 !important;\n  font-size: 0.95rem !important;\n  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3) !important;\n  transition: all 0.2s ease !important;\n}\n\n.swal2-confirm-professional:hover {\n  transform: translateY(-1px) !important;\n  box-shadow: 0 6px 16px rgba(255, 107, 53, 0.4) !important;\n}\n\n.swal2-cancel-professional {\n  background: #6c757d !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 0.75rem 2rem !important;\n  font-weight: 600 !important;\n  font-size: 0.95rem !important;\n  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3) !important;\n  transition: all 0.2s ease !important;\n}\n\n.swal2-cancel-professional:hover {\n  background: #5a6268 !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4) !important;\n}\n\n/* Estilos para inputs del popup */\n.swal2-input:focus {\n  border-color: #ff6b35 !important;\n  box-shadow: 0 0 0 0.2rem rgba(255, 107, 53, 0.25) !important;\n  outline: none !important;\n}\n\n.swal2-input {\n  transition: border-color 0.2s ease, box-shadow 0.2s ease !important;\n}\n\n.manual-link {\n  margin-top: 0.5rem;\n}\n\n.manual-link a {\n  color: #0d6efd;\n  text-decoration: none;\n  font-size: 0.875rem;\n}\n\n.manual-link a:hover {\n  text-decoration: underline;\n}\n\n.upload-area {\n  border: 2px dashed #dee2e6;\n  border-radius: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  cursor: pointer;\n  transition: border-color 0.15s ease-in-out;\n}\n\n.upload-area:hover {\n  border-color: #0d6efd;\n}\n\n.upload-area.dragover {\n  border-color: #0d6efd;\n  background-color: rgba(13, 110, 253, 0.05);\n}\n\n.upload-icon {\n  font-size: 2rem;\n  color: #6c757d;\n  margin-bottom: 0.5rem;\n}\n\n.upload-text {\n  color: #6c757d;\n  margin-bottom: 0.25rem;\n}\n\n.upload-hint {\n  font-size: 0.875rem;\n  color: #adb5bd;\n}\n\n.modal-footer {\n  border-top: 1px solid #dee2e6;\n  padding: 1rem;\n  display: flex;\n  justify-content: flex-end;\n  text-align: right;\n  flex-shrink: 0;\n  background-color: #fff;\n}\n\n.btn {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  text-decoration: none;\n  display: inline-block;\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #0d6efd;\n  border-color: #0d6efd;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #0b5ed7;\n  border-color: #0a58ca;\n}\n\n.btn-warning {\n  color: #fff;\n  background-color: #fd7e14;\n  border-color: #fd7e14;\n}\n\n.btn-warning:hover {\n  color: #fff;\n  background-color: #e8690b;\n  border-color: #e8690b;\n}\n\n.btn-warning:disabled {\n  opacity: 0.65;\n  pointer-events: none;\n  background-color: #fd7e14;\n  border-color: #fd7e14;\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #5c636a;\n  border-color: #565e64;\n}\n\n.btn:disabled {\n  opacity: 0.65;\n  pointer-events: none;\n}\n\n/* Estilos para campos manuales */\n.manual-fields {\n  margin-top: 1rem;\n}\n\n.manual-fields .form-group {\n  margin-bottom: 0.75rem;\n}\n\n/* Estilos para validación */\n.form-control.is-invalid {\n  border-color: #dc3545;\n  padding-right: calc(1.5em + 0.75rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23dc3545'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='m5.8 4.6 2.4 2.4m0-2.4L5.8 7'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.1875rem) center;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n\n.invalid-feedback {\n  display: block;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 0.875em;\n  color: #dc3545;\n}\n\n/* Estilos para el estado de carga */\n.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  vertical-align: text-bottom;\n  border: 0.125em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  animation: spinner-border 0.75s linear infinite;\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Estilos para la nueva funcionalidad de autosuggest */\n\n.country-support-info {\n  margin-bottom: 0.75rem;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  background-color: #f8f9fa;\n  border-left: 3px solid #17a2b8;\n}\n\n.country-support-info .text-warning {\n  background-color: #fff3cd;\n  border-left-color: #ffc107;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n}\n\n.manual-link {\n  margin-top: 0.5rem;\n}\n\n.manual-link a {\n  color: #007bff;\n  text-decoration: none;\n  font-size: 0.875rem;\n  display: inline-flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n\n.manual-link a:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\n\n.address-input-wrapper {\n  position: relative;\n}\n\n.address-input {\n  padding-right: 2.5rem;\n}\n\n.manual-address-fields {\n  border: 1px solid #e9ecef;\n  border-radius: 0.375rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n}\n\n/* Mejoras visuales para el autocompletado de Google Maps */\n.pac-container {\n  border-radius: 0.375rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border: 1px solid #dee2e6;\n  margin-top: 0.25rem;\n}\n\n.pac-item {\n  padding: 0.75rem;\n  border-bottom: 1px solid #f1f3f4;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.pac-item:hover {\n  background-color: #f8f9fa;\n}\n\n.pac-item-selected {\n  background-color: #e3f2fd;\n}\n\n.pac-matched {\n  font-weight: 600;\n  color: #1976d2;\n}\n\n/* Estilos para la dirección seleccionada */\n.selected-address-display {\n  margin-top: 1rem;\n}\n\n.selected-address-display .alert {\n  border-radius: 0.5rem;\n  border: 1px solid #b3d7ff;\n  background-color: #e7f3ff;\n  color: #004085;\n  padding: 0.75rem 1rem;\n}\n\n.selected-address-display .alert strong {\n  color: #002752;\n}\n\n/* Estilos globales para forzar tema claro en Google Maps */\n:root {\n  color-scheme: light !important;\n}\n\n/* Forzar estilos en el web component de Google Maps */\ngmp-place-autocomplete {\n  color-scheme: light !important;\n  --color-scheme: light !important;\n  --gm-input-color: #495057 !important;\n  --gm-input-background: #ffffff !important;\n  --gm-input-border: #ced4da !important;\n  --gm-input-placeholder-color: #6c757d !important;\n}\n\n/* Estilos ultra específicos para el input */\ngmp-place-autocomplete::part(input) {\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n  color-scheme: light !important;\n  --color-scheme: light !important;\n}\n\n/* Forzar estilos en todos los estados del input */\ngmp-place-autocomplete::part(input):focus,\ngmp-place-autocomplete::part(input):hover,\ngmp-place-autocomplete::part(input):active,\ngmp-place-autocomplete::part(input):visited {\n  color: #495057 !important;\n  background-color: #ffffff !important;\n  -webkit-text-fill-color: #495057 !important;\n}\n\n/* Estilos para el placeholder en todos los navegadores */\ngmp-place-autocomplete::part(input)::placeholder,\ngmp-place-autocomplete::part(input)::-webkit-input-placeholder,\ngmp-place-autocomplete::part(input)::-moz-placeholder,\ngmp-place-autocomplete::part(input)::-ms-input-placeholder,\ngmp-place-autocomplete::part(input)::-ms-placeholder {\n  color: #6c757d !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #6c757d !important;\n}\n\n/* Estilos para scroll suave */\n.modal-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.modal-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.modal-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* Estilos para el header fijo */\n.modal-header {\n  flex-shrink: 0;\n  background-color: #fff;\n  z-index: 10;\n}\n\n/* Responsive para la nueva funcionalidad */\n@media (max-width: 768px) {\n  .residence-change-modal {\n    max-height: 85vh;\n  }\n  \n  .modal-body {\n    padding: 1rem;\n  }\n  \n  .manual-address-fields {\n    padding: 0.75rem;\n  }\n  \n  .country-support-info {\n    font-size: 0.8rem;\n  }\n  \n  .manual-link a {\n    font-size: 0.8rem;\n  }\n  \n  .selected-address-display .alert {\n    padding: 0.5rem 0.75rem;\n    font-size: 0.9rem;\n  }\n}\n\n/* Para pantallas muy pequeñas */\n@media (max-width: 480px) {\n  .residence-change-modal {\n    max-height: 90vh;\n  }\n  \n  .modal-body {\n    padding: 0.75rem;\n  }\n  \n  .modal-footer {\n    padding: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
